/**
 * 人民币中间价顶部基本信息
 */
 import React from "react"
 import { store } from "./store"
 import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
 import { Observer } from "mobx-react-lite"
 import { BondLoadMore } from "../../shared/quote_load_more"
 import { ChartType } from "../../shared/utils"
 
 export function CNYBasicInfo() {

  return (
    <Observer>
      {() => (
        <div className="bond-container">
          <div className="bond-container-left">
            <div>
              {store.chart_mouse_move_data ? quote_chart[quote_item_name.最新价](store.chart_mouse_move_data.newPrice, 0, store.chart_mouse_move_data._color).new_element : single_quote[quote_item_name.最新价](store.StockDetail).new_element}
              <p className="bond-percent">
                {store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌幅](store.chart_mouse_move_data.zdf, 0, store.chart_mouse_move_data._color).new_element : single_quote[quote_item_name.涨跌幅](store.StockDetail).new_element}&nbsp;&nbsp;&nbsp;
                {store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌额](store.chart_mouse_move_data.zde, store.chart_mouse_move_data._color).new_element : single_quote[quote_item_name.涨跌额](store.StockDetail).new_element}
              </p>
            </div>
          </div>
          <div className="bond-container-right">
            {store.chart_mouse_move_data && store.chartType != ChartType.分时 ? (
              <>
                <ul>
                  <li>
                    <p>昨收</p>
                    {quote_chart[quote_item_name.昨收](store.chart_mouse_move_data.zuoshou).element}
                  </li>
                  <li>
                    <p>今开</p>
                    {quote_chart[quote_item_name.今开](store.chart_mouse_move_data.jinkai, store.chart_mouse_move_data.jkColor).element}
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>最高</p>
                    {quote_chart[quote_item_name.最高](store.chart_mouse_move_data.maxPrice, store.chart_mouse_move_data.maxPriceColor).element}
                  </li>
                  <li>
                    <p>最低</p>
                    {quote_chart[quote_item_name.最低](store.chart_mouse_move_data.minPrice, store.chart_mouse_move_data.minPriceColor).element}
                  </li>
                </ul>
              </>
            ) : (
              <>
                <ul>
                  <li>
                    <p>昨收</p>
                    {single_quote[quote_item_name.昨收](store.StockDetail).element}
                  </li>
                  <li>
                    <p>今开</p>
                    {single_quote[quote_item_name.今开](store.StockDetail).element}
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>最高</p>
                    {single_quote[quote_item_name.最高](store.StockDetail).element}
                  </li>
                  <li>
                    <p>最低</p>
                    {single_quote[quote_item_name.最低](store.StockDetail).element}
                  </li>
                </ul>
              </>
            )}
          </div>
          <BondLoadMore />
        </div>
      )}
    </Observer>
  )
 }
 